import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import avatar from '../../images/user_avatar.png';
import {withRouter} from 'react-router';
import BlogTeaser from './blog_teaser';
import DATA from '../../data/article_data'

import {
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";


class BlogList extends Component {

    constructor(props){
        super(props);
        //console.log(props,this.state)
        this.state = { 
            blog_data : DATA.blog_data,
            articles: DATA.articles,
        }
    };

    items = DATA.blog_data.map(item => {
        return <BlogTeaser name={item.name} teaser={item.teaser} source={item.source} link={item.link} />;
    });

  render() {
    return (
        <div className="blogs_list blog_section">
        <h2>Industry News</h2>
        <ul className="flex-grid-thirds">
            {this.items}
        </ul>
        </div>
    );
  }
}

export default withRouter(BlogList);